import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, makeStyles, Typography } from '@material-ui/core';
import KenAutoComplete from '../../../global_components/KenAutoComplete/index';
import KenSelect from '../../../global_components/KenSelect';
import KenLoader from '../../../Components/KenLoader/index';
import KenInputField from '../../../global_components/KenInputField';
import KenDialog from '../../../global_components/KenDialogBox';
import {
  getNoofSpecialization,
  getAcademicFilter,
  postMasterSubjects,
} from '../../../Utils/apiServices';
const useStyles = makeStyles((theme) => ({}));
export default function AddMasterImport(props) {
  const defaultValues = {
    subject: null,
    subjectCode: '',
    specialization: null,
    category: '',
    prerequsit: [],
    offset: '',
    duration: '',
  };
  const classes = useStyles();
  const {
    selectedTerm,
    proceedMaster,
    setProceedMaster,
    setShowAddMasterImport,
    programID,
    setNewMasterUpload,
  } = props;
  const [formData, setFormData] = useState(defaultValues);
  const [loading, setLoading] = useState(false);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([
    { label: 'Mandatory', value: 'Mandatory' },
    { label: 'Elective', value: 'Elective' },
  ]);
  useEffect(() => {
    const apiCalls = async () => {
      const academicData = await getAcademicFilter();
      const subjectOptions = [];
      const AcademicFilterObject = Object.entries(academicData?.Courses);
      const subjectOptionsNew = AcademicFilterObject.map(([item, keyVal]) => {
        return {
          title: item,
          label: keyVal?.courseName,
          value: item,
          id: keyVal?.id,
          courseId: keyVal?.courseId,
          academicId: keyVal?.courseAcademicProgramId,
        };
      });
      if (programID != undefined) {
        subjectOptionsNew.map((item) => {
          if (item?.academicId === programID) {
            subjectOptions.push(item);
          }
        });
        setSubjectOptions(subjectOptions);
      }
      // Specialization API
      let id = programID;
      const specializationData = await getNoofSpecialization(id);
      let specializationOptions = [];
      specializationData.map((item2) => {
        specializationOptions.push({
          title: item2?.Name,
          value: item2?.id,
        });
      });
      setSpecializationOptions(specializationOptions);
    };
    apiCalls();
  }, []);
  useEffect(() => {
    if (proceedMaster) {
      // allow to proceed only if all values are added
    }
  }, [proceedMaster]);

  const handleAutocomplete = (name, e, data, objValue) => {
    if (name === 'subject') {
      setFormData({
        ...formData,
        [name]: objValue,
        subjectCode: objValue?.courseId,
      });
    } else {
      setFormData({
        ...formData,
        [name]: objValue,
      });
    }
  };
  const handleChangeFormFields = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const addMasterRecord = () => {
    console.log('formData', formData, selectedTerm);
    setLoading(true);
    let preRequisites = formData.prerequsit.map((item, index) => ({
      [`preRequisitesCourseId` + (index + 1)]: item.id,
    }));
    let termSplit = selectedTerm?.elem?.currentTerm.split(/([0-9]+)/);
    let payload = {
      departmentId: programID,
      courseId: formData.subject.id,
      termNumber: `Term ${termSplit[1]}`,
      specializationId: formData.specialization.value,
      category: formData.category,
      offset: formData.offset,
      duration: formData.duration,
    };
    preRequisites.forEach((zz) => {
      Object.keys(zz).forEach((e) => {
        payload[e] = zz[e];
      });
    });
    console.log('payload', [payload]);
    postMasterSubjects([payload])
      .then((res) => {
        console.log(res);
        setLoading(false);
        setProceedMaster(false);
        setShowAddMasterImport(false);
        setNewMasterUpload(true);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  const proceedMasterClose = () => {
    setProceedMaster(false);
  };
  return (
    <Box>
      {loading && <KenLoader />}
      <Grid container xs={12} spacing={2}>
        <Grid item xs={6}>
          <div className="accal">
            <KenAutoComplete
              name="subject"
              options={subjectOptions}
              label="Subject"
              value={formData.subject}
              onChange={(el, value) =>
                handleAutocomplete('subject', el, subjectOptions, value)
              }
              required={true}
              multiple={false}
            />
          </div>
        </Grid>
        <Grid item xs={6}>
          <KenInputField
            label="Subject Code"
            required
            className="weekNo-input"
            placeholder="Subject Code"
            name="subjectCode"
            value={formData.subjectCode}
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <div className="accal">
            <KenAutoComplete
              name="specialization"
              options={specializationOptions}
              label="Specialization"
              value={formData.specialization}
              onChange={(el, value) =>
                handleAutocomplete(
                  'specialization',
                  el,
                  specializationOptions,
                  value
                )
              }
              required={true}
              multiple={false}
            />
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className="catergory-selectbox">
            <KenSelect
              required={true}
              options={categoryOptions}
              name="category"
              label={'Category'}
              value={formData.category}
              onChange={(e) => {
                handleChangeFormFields(e);
              }}
            />
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className="accal">
            <KenAutoComplete
              name="prerequsit"
              options={subjectOptions}
              label="Pre-Requsit"
              value={formData.prerequsit}
              onChange={(el, value) =>
                handleAutocomplete('prerequsit', el, subjectOptions, value)
              }
              required={true}
              multiple={true}
            />
          </div>
        </Grid>
        <Grid item xs={6}>
          <KenInputField
            label="Offset"
            required
            className="weekNo-input"
            helpTextVal="No of days between term start date and subject start date"
            placeholder="Offset"
            name="offset"
            type="Number"
            value={formData.offset}
            onChange={(e) => {
              handleChangeFormFields(e);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <KenInputField
            label="Duration"
            required
            className="weekNo-input"
            helpTextVal="No of working days of the subject"
            placeholder="Duration"
            name="duration"
            type="Number"
            value={formData.duration}
            onChange={(e) => {
              handleChangeFormFields(e);
            }}
          />
        </Grid>
      </Grid>
      {/* Master Add Confirmation */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Confirmation
                </Typography>
              </Grid>
            </Grid>
          </>
        }
        open={proceedMaster}
        handleClose={() => proceedMasterClose()}
        negativeButtonClick={() => proceedMasterClose()}
        positiveButtonClick={() => addMasterRecord()}
        positiveButtonText="Proceed"
        negativeButtonText="Cancel"
        hidePositiveButton={false}
        maxWidth="lg"
        dividers
      >
        <Grid container xs={12}>
          <Typography>
            Please proceed with this action only if you have obtained the
            relevant permissions.
          </Typography>
        </Grid>
      </KenDialog>
    </Box>
  );
}
